module.exports = __webpack_public_path__ + "static/media/zxs_syrq.380d0470.png";